console.log('0000')
if($('.buy-buttons_main').length > 0){
 if ($(this).scrollTop() > $('.buy-buttons_main').offset().top+100) {
   $('#sticky-atc').addClass('show');
  }
  $(window).scroll(function(){
    if ($(this).scrollTop() > $('.buy-buttons_main').offset().top+100) {
       $('#sticky-atc').addClass('show');
    } else {
       $('#sticky-atc').removeClass('show');
    }
  }); 
}

document.addEventListener( 'DOMContentLoaded', function() {
  let splide = new Splide('#product-slider', {
      autoplay: false, 
      mediaQuery: 'min', 
      type: 'loop', 
      focus: 'center', 
      perPage: 2, 
      perMove: 1, 
      gap: '-30px', 
      breakpoints: { 
        540: { perPage: 3, gap: 0 }, 
        640: { perPage: 4 }, 
        840: { perPage: 5 } 
      }      
    });

    splide.on('move', function () {
      requestAnimationFrame(() => updateSlideClasses(splide)); // Ensures instant update
    });

    splide.on('mounted', function () {
      requestAnimationFrame(() => updateSlideClasses(splide)); // Ensures instant update
    });

    function updateSlideClasses(splide) {
      let slides = splide.Components.Elements.slides;
      let activeIndex = splide.index;

      // Remove all previous classes in one step
      slides.forEach(slide => slide.classList.remove('is-prev', 'is-next', 'is-active'));

      // Add classes in a single operation
      slides[activeIndex]?.classList.add('is-active'); // Main active slide
      slides[getLoopIndex(activeIndex - 1, slides.length)]?.classList.add('is-prev'); // Previous slide
      slides[getLoopIndex(activeIndex + 1, slides.length)]?.classList.add('is-next'); // Next slide
    }

    function getLoopIndex(index, length) {
      return (index + length) % length; // Ensures looping effect
    }

    splide.mount();
} );

$(document).ready(function() {
  function updateSlickClasses(slick, currentSlide) {
    $('.gooat-flavours_row .slick-slide').removeClass('slick-siblings');
    
    // Get previous and next slide indexes
    var prevSlide = (currentSlide === 0) ? slick.slideCount - 1 : currentSlide - 1;
    var nextSlide = (currentSlide === slick.slideCount - 1) ? 0 : currentSlide + 1;
    
    // Add classes to previous and next slides
    $('.gooat-flavours_row .slick-slide[data-slick-index="' + prevSlide + '"]').addClass('slick-siblings');
    $('.gooat-flavours_row .slick-slide[data-slick-index="' + nextSlide + '"]').addClass('slick-siblings');
  }

// Initialize Slick and update classes on load & after slide change
// $('.gooat-flavours_row')
//     .on('init', function(event, slick) {
//       updateSlickClasses(slick, slick.currentSlide); // Run on load
//     })
//     .on('afterChange', function(event, slick, currentSlide) {
//       updateSlickClasses(slick, currentSlide); // Run after each slide change
//     })
//     .slick({
//         dots: false,
//         slidesToShow: 5,
//         slidesToScroll: 1,
//         centerMode: true,
//         centerPadding: '0',
//         infinite: false,
//         swipe: true,
//         swipeToSlide: true,
//         initialSlide: 3,
//         speed: 600,
//         asNavFor: '.gooat-flavours_dots',
//         responsive: [
//             {
//                 breakpoint: 989,
//                 settings: {
//                     slidesToShow: 3
//                 }
//             },
//             {
//                 breakpoint: 749,
//                 settings: {
//                     slidesToShow: 1,
//                     centerPadding: '25%',
//                     arrows: false
//                 }
//             }
//         ]
//     });


  $(".gooat-flavours_dots").slick({
    dots: false,
    arrows:false,
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    infinite:true,
    asNavFor: '.gooat-flavours_row'
  });

  $(".product-ingredients-list").slick({
      arrows:true,
      dots: true,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '80px',
          infinite: true
        }
      }
    ]
  });

  $(".video-list_row").slick({
    arrows:true,
    dots: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '80px',
          infinite: true
        }
      }
    ]
  });

  // $('.video-list_item-play-pause').click(function(){
  //   $(this).toggleClass('play');
  //   $(this).next('video').trigger('play');
    
  //   var mediaVideo = $(this).next('video').get(0);
  //   if (mediaVideo.paused) {
  //        mediaVideo.play();
  //    } else {
  //        mediaVideo.pause();
  //   }   
  // });

  $('body').on('click','.customer_details_main .has_popable', function(){    
    $('#customer-details-popup').find('.customer_description').html($(this).closest('.customer_card').find('.customer_desc').html());
    $('#customer-details-popup').attr('open','');
    $('html').addClass('lock-all');
  });

   $('body').on('click','.main_popup .modal__close-button,.popup__overlay', function(){    
    $(this).closest('.main_popup').removeAttr('open');
    $('html').removeClass('lock-all');
  });

  $('.video-list_item-play-pause').click(function () {
    var clickedButton = $(this);
    var clickedVideo = clickedButton.next('video').get(0);

    // Pause all videos except the clicked one
    $('video').each(function () {
        if (this !== clickedVideo) {
            this.pause();
            $(this).prev('.video-list_item-play-pause').removeClass('play');
        }
    });

    // Toggle play/pause for the clicked video
    clickedButton.toggleClass('play');
    if (clickedVideo.paused) {
        clickedVideo.play();
    } else {
        clickedVideo.pause();
    }
  });

  function addremovegift(cart,threshhold,free_gift){
    if(free_gift.available){
      const product = cart.items.find(item => item.id === free_gift.variants[0].id);
      console.log(product ? "Product found:" : "Product NOT in cart", product);
      if(product){
       var ctp = cart.total_price - product.price; 
      }else{
       var ctp = cart.total_price;
      }
       if(ctp > threshhold && product == undefined && cart.item_count > 0){
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append("id", free_gift.variants[0].id);
        formData.append("quantity", 1);
        formData.append("properties[_freegift]", 'yes');
  
        if (window.cart) {
          formData.append(
              'sections',
              window.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          window.cart.setActiveElement(document.activeElement);
        }
  
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {            
            if (!window.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });  
            
            window.cart.renderContents(response);
          })
          .catch((error) => {
            console.error("Add to Cart Error:", error);
          })
          .finally(() => {
            if (window.cart && window.cart.classList.contains('is-empty')) {
              window.cart.classList.remove('is-empty');
            }
          });        
        
      }else if(ctp < threshhold && product){
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
    
        const formData = new FormData();
        formData.append("id", free_gift.variants[0].id);
        formData.append("quantity", 0);
  
        if (window.cart) {
          formData.append(
              'sections',
              window.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          window.cart.setActiveElement(document.activeElement);
        }
  
        config.body = formData;
  
        fetch(`${routes.cart_change_url}`, config)
          .then((response) => response.json())
          .then((response) => {            
            if (!window.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });  
            
            window.cart.renderContents(response);
          })
          .catch((error) => {
            console.error("Add to Cart Error:", error);
          })
          .finally(() => {
            if (window.cart && window.cart.classList.contains('is-empty')) {
              window.cart.classList.remove('is-empty');
            }
          });      
      } 
    }    
  }

  function checkbyob(cart){
    console.log(cart);
    var qty = 0;
    $(cart.items).each(function(i,e){
      if(e.product_type == 'byob'){        
        qty += e.quantity;
      }
    });
    $('.checkouterr').remove();
    if(qty > 0 && qty < parseInt(window.settings.byoblimit)){
     $('#CartDrawer .drawer__footer .cart__ctas, .cart__footer .cart__ctas').before(`<p class="checkouterr">${window.settings.byoberrmessage}</p>`);
     $('#CartDrawer .cart__checkout-button[name="checkout"], .cart__footer .cart__checkout-button[name="checkout"]').attr('type','button').attr('disabled','disabled');
    }else{
     $('#CartDrawer .cart__checkout-button[name="checkout"], .cart__footer .cart__checkout-button[name="checkout"]').attr('type','submit').removeAttr('disabled');
    }    
  }

  function getYtBundleAdjustedTotal(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;

    var bundleLineTotal = 0;
    var bundleBoxTotal = 0;
    var seenBundles = {};
    var hasBundle = false;

    $(cart.items).each(function(i, item) {
      var properties = item.properties || {};
      var finalBundlePrice = properties._finalBundlePrice;

      if (finalBundlePrice === undefined || finalBundlePrice === null || finalBundlePrice === '') return;

      hasBundle = true;
      bundleLineTotal += parseInt(item.final_line_price || item.line_price || 0, 10);

      var bundleKey = properties._bundleId || properties._bundleSignature || item.key || ('bundle-' + i);
      if (!seenBundles[bundleKey]) {
        seenBundles[bundleKey] = true;
        bundleBoxTotal += Math.round(parseFloat(finalBundlePrice) * 100);
      }
    });

    if (!hasBundle) return null;
    return parseInt(cart.total_price || 0, 10) - bundleLineTotal + bundleBoxTotal;
  }

  function updateYtBundleLineTotals(cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    var seenBundles = {};
    $(cart.items).each(function(i, item) {
      var properties = item.properties || {};
      var finalBundlePrice = properties._finalBundlePrice;
      if (finalBundlePrice === undefined || finalBundlePrice === null || finalBundlePrice === '') return;

      var bundleKey = properties._bundleId || properties._bundleSignature || item.key || ('bundle-' + i);
      var displayCents = seenBundles[bundleKey] ? 0 : Math.round(parseFloat(finalBundlePrice) * 100);
      seenBundles[bundleKey] = true;

      var displayMoney = formatMoney(displayCents, window.settings.moneyWithCurrencyFormat || window.settings.moneyFormat);
      var selectors = [
        '#CartDrawer-Item-' + (i + 1) + ' .cart-item__price-wrapper',
        '#CartItem-' + (i + 1) + ' .cart-item__price-wrapper'
      ];

      $(selectors.join(',')).each(function() {
        var priceTarget = $(this).find('.price--end').last();
        if (priceTarget.length) {
          priceTarget.text(displayMoney);
        } else {
          $(this).html('<span class="price price--end">' + displayMoney + '</span>');
        }
      });
    });
  }

  function updateYtBundleDisplayedTotals(cart) {
    var adjustedTotal = getYtBundleAdjustedTotal(cart);
    if (adjustedTotal === null) return;

    var displayMoney = formatMoney(adjustedTotal, window.settings.moneyWithCurrencyFormat || window.settings.moneyFormat);
    $('.totals__total-value').text(displayMoney);
    $('#cart-live-region-text, #CartDrawer-LiveRegionText').text('New estimated total: ' + displayMoney);
    updateYtBundleLineTotals(cart);
  }

  var ytBundleAttributeKeys = [
    'yt_bundle_present',
    'yt_bundle_app',
    'yt_bundle_ids',
    'yt_bundle_titles',
    'yt_bundle_final_prices',
    'yt_bundle_fixed_total',
    'yt_bundle_line_total',
    'yt_bundle_item_count',
    'yt_bundle_parent_variant_ids',
    'yt_bundle_parent_product_ids',
    'yt_bundle_minimum_quantities'
  ];
  var ytBundleAttributesInFlight = null;
  var ytBundleAttributesSignature = '';

  function buildYtBundleCartAttributes(cart) {
    var attributes = {};
    var bundles = {};
    var order = [];
    var fixedTotal = 0;
    var lineTotal = 0;
    var itemCount = 0;

    if (cart && cart.items && cart.items.length) {
      $(cart.items).each(function(i, item) {
        var properties = item.properties || {};
        var finalBundlePrice = properties._finalBundlePrice;
        if (finalBundlePrice === undefined || finalBundlePrice === null || finalBundlePrice === '') return;

        var bundleId = properties._bundleId || properties._bundleSignature || item.key || ('bundle-' + i);
        if (!bundles[bundleId]) {
          bundles[bundleId] = {
            id: bundleId,
            title: item.product_title || item.title || '',
            finalPrice: String(finalBundlePrice),
            parentVariantId: properties._parentVariantId || '',
            parentProductId: properties._parentProductId || '',
            minimumQuantity: properties._bundleMinimumQuantity || '',
            lineTotal: 0,
            quantity: 0
          };
          order.push(bundleId);
          fixedTotal += Math.round(parseFloat(finalBundlePrice) * 100);
        }

        bundles[bundleId].lineTotal += parseInt(item.final_line_price || item.line_price || 0, 10);
        bundles[bundleId].quantity += parseInt(item.quantity || 0, 10);
        lineTotal += parseInt(item.final_line_price || item.line_price || 0, 10);
        itemCount += parseInt(item.quantity || 0, 10);
      });
    }

    if (!order.length) {
      ytBundleAttributeKeys.forEach(function(key) {
        attributes[key] = '';
      });
      return attributes;
    }

    var orderedBundles = order.map(function(id) { return bundles[id]; });
    attributes.yt_bundle_present = 'true';
    attributes.yt_bundle_app = 'YourToken';
    attributes.yt_bundle_ids = orderedBundles.map(function(bundle) { return bundle.id; }).join(',');
    attributes.yt_bundle_titles = orderedBundles.map(function(bundle) { return bundle.title; }).join(' | ');
    attributes.yt_bundle_final_prices = orderedBundles.map(function(bundle) { return bundle.finalPrice; }).join(',');
    attributes.yt_bundle_fixed_total = String(fixedTotal / 100);
    attributes.yt_bundle_line_total = String(lineTotal / 100);
    attributes.yt_bundle_item_count = String(itemCount);
    attributes.yt_bundle_parent_variant_ids = orderedBundles.map(function(bundle) { return bundle.parentVariantId; }).join(',');
    attributes.yt_bundle_parent_product_ids = orderedBundles.map(function(bundle) { return bundle.parentProductId; }).join(',');
    attributes.yt_bundle_minimum_quantities = orderedBundles.map(function(bundle) { return bundle.minimumQuantity; }).join(',');

    return attributes;
  }

  function syncYtBundleCartAttributes(cart) {
    if (!cart) return $.Deferred().resolve().promise();

    var attributes = buildYtBundleCartAttributes(cart);
    var existingAttributes = cart.attributes || {};
    var changed = false;

    ytBundleAttributeKeys.forEach(function(key) {
      if (String(existingAttributes[key] || '') !== String(attributes[key] || '')) {
        changed = true;
      }
    });

    var signature = JSON.stringify(attributes);
    if (!changed || signature === ytBundleAttributesSignature) {
      return $.Deferred().resolve().promise();
    }

    ytBundleAttributesSignature = signature;

    if (ytBundleAttributesInFlight) {
      return ytBundleAttributesInFlight;
    }

    ytBundleAttributesInFlight = $.ajax({
      url: '/cart/update.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ attributes: attributes })
    }).always(function() {
      ytBundleAttributesInFlight = null;
    });

    return ytBundleAttributesInFlight;
  }

  var ytBundleTotalTimer = null;
  function refreshYtBundleDisplayedTotals() {
    clearTimeout(ytBundleTotalTimer);
    ytBundleTotalTimer = setTimeout(function() {
      $.getJSON('/cart.js', function(cart) {
        updateYtBundleDisplayedTotals(cart);
        syncYtBundleCartAttributes(cart);
      });
    }, 150);
  }

  refreshYtBundleDisplayedTotals();

  document.addEventListener('click', function(event) {
    var checkoutButton = event.target.closest && event.target.closest('.gokwik-checkout button');
    if (!checkoutButton || checkoutButton.dataset.ytBundleSynced === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    $.getJSON('/cart.js')
      .then(function(cart) {
        return syncYtBundleCartAttributes(cart);
      })
      .always(function() {
        checkoutButton.dataset.ytBundleSynced = 'true';
        if (typeof window.onCheckoutClick === 'function') {
          window.onCheckoutClick(checkoutButton);
        } else {
          checkoutButton.click();
        }
        setTimeout(function() {
          delete checkoutButton.dataset.ytBundleSynced;
        }, 1000);
      });
  }, true);

  subscribe(PUB_SUB_EVENTS.cartUpdate, function(eventData) {
     console.log("Cart updated:", eventData);
     var threshhold = parseInt(window.settings.freegift_threshhold) * 100;
     var free_gift = window.settings.free_gift;
     if(eventData.source == 'product-form'){
       $.getJSON('/cart.js', function(cart){
         addremovegift(cart,threshhold,free_gift);
         checkbyob(cart);
         updateYtBundleDisplayedTotals(cart);
         syncYtBundleCartAttributes(cart);
      });
       
     }else{     
       addremovegift(eventData.cartData,threshhold,free_gift);
       checkbyob(eventData.cartData);
       syncYtBundleCartAttributes(eventData.cartData);
       refreshYtBundleDisplayedTotals();
     }
  });

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
  var currencyFormat = window.settings.currencyCodeEnabled ? window.settings.moneyWithCurrencyFormat : window.settings.moneyFormat;

  var addedcnt = 0;
  var bundle_compare_price = 0;
  var bundle_total_price = 0;
  function activecheck(addedcnt,bundle_compare_price,bundle_total_price){
    $('.bundle-product-list .currentcnt').html(addedcnt);
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      $('.bundle-product-item__cta:not(.added)').attr('disabled','disabled');
      $('.bundle-add_to_cart_button .blank_text').hide();
      $('.bundle-add_to_cart_button .checkout_text').show();
      $('.bundle-add_to_cart_button').removeAttr('disabled').addClass('readytoadd button--gradient');
      $('.bundle-product-list .quantity__button[name="plus"]').attr('disabled','disabled');
      $('.review_drawer_button').addClass('readytoadd').find('.btntext').text('Review your bundle');
    }else{
      $('.bundle-product-item__cta:not(.added)').removeAttr('disabled');
      $('.bundle-add_to_cart_button .blank_text').show();
      $('.bundle-add_to_cart_button .checkout_text').hide();
      $('.bundle-add_to_cart_button').attr('disabled','disabled').removeClass('readytoadd button--gradient');
      $('.bundle-product-list .quantity__button[name="plus"]').removeAttr('disabled');
      $('.review_drawer_button').removeClass('readytoadd').find('.btntext').text($('.review_drawer_button').attr('data-button-text'));
      // $('.bundle-preview_cart-prices').hide();
    }
    if($('.bundle-preview_cart .bundle-preview_cart-buttons .carttotal_price').attr('data-percetage') != ''){
      var bundpercentag = parseInt($('.bundle-preview_cart .bundle-preview_cart-buttons .carttotal_price').attr('data-percetage'));
      var finlbundle = bundle_total_price - ((bundle_total_price * bundpercentag) / 100);
      $('.bundle-preview_cart .bundle-preview_cart-buttons .carttotal_price').html(formatMoney(finlbundle, currencyFormat));
    }else{
      $('.bundle-preview_cart .bundle-preview_cart-buttons .carttotal_price').html($('.bundle-preview_cart .bundle-preview_cart-buttons .carttotal_price').attr('data-fixedprice'));
    }
    
    // $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));
    
    if(addedcnt > 0){
      $('.bundle-preview_cart').removeClass('empty');
    }else{
      $('.bundle-preview_cart').addClass('empty');
    }
  }

  function qtyatc(totalqty, _this){
    if(totalqty > 0){
      $(_this).closest('.quick-add').find('.bundle-product-item__cta').hide();
      $(_this).closest('.quick-add').find('.quantity').removeClass('hidden');
      $(_this).closest('.quick-add').find('.bundle-product-item__cta').attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
    }else{
      $(_this).closest('.quick-add').find('.bundle-product-item__cta').show();
      $(_this).closest('.quick-add').find('.quantity').addClass('hidden');
      $(_this).closest('.quick-add').find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--primary').html(`Add to box`);
    }
  }
  
  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    // bundle_compare_price += parseInt($(this).attr('data-compare_price'));
    bundle_total_price += parseInt($(this).attr('data-price'));
    var totalqty = parseInt($(this).closest('.quick-add').find('.quantity [name="quantity"]').val()) + 1;
    qtyatc(totalqty, this);
    $(this).closest('.quick-add').find('.quantity [name="quantity"]').val(totalqty);
    
    activecheck(addedcnt,bundle_compare_price,bundle_total_price);     
    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--gradient').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall">x</span>`);
    var featuredimage = $(this).closest('.product-card-wrapper').attr('data-featuredimage');
    var itemtitle = $(this).closest('.product-card-wrapper').attr('data-product-name');
    var itembox = `<div class="bundle-preview_cart-item-wrapper" 
    data-qty="${totalqty}"
    data-vid="${$(this).closest('.product-card-wrapper').attr('data-variant-id')}" 
    data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"
    data-price="${$(this).closest('.product-card-wrapper').attr('data-product-price')}"
    >
    <img src="${featuredimage}" loading="lazy" width="60" height="60" alt="">
    <h4 class="itemtitle">${itemtitle}</h4>
    <div class="bndl-preview-qtybox">
      <div class="quantity">
        <button class="quantity__button minus" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
            </path>
          </svg>
        </button>
        <input class="quantity__input" type="number" name="bundle_quantity" value="1" readonly>
        <button class="quantity__button plus" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
            <path fill-rule="evenodd"o clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
          </svg>
        </button>
      </div>
    </div>
    <div class="hidden bundle-preview_car-item-remove text--xsmall">x</div>
    </div>`; 
    $('.bundle-preview_cart-items').append(itembox);
    
  });

  $('body').on('click', '.bundle-products-mainwrapper .product-card-wrapper .quantity__button[name="plus"]', function(e){
    addedcnt += 1;
    // bundle_compare_price += parseInt($(this).closest('.product-item').find('.block-swatch-list input[type="radio"]:checked').attr('data-compprice'));
    bundle_total_price += parseInt($(this).closest('.card__content').find('.bundle-product-item__cta').attr('data-price'));
    var currentqty = parseInt($(this).closest('.quantity').find('[name="quantity"]').val());
    qtyatc(currentqty, this);
    
    // $(this).closest('.quantity-selector').find('[name="quantity"]').val(totalqty);
    activecheck(addedcnt,bundle_compare_price,bundle_total_price);     
    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--primary').html(`Added`);
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 320.591 320.591" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg></span>`);
    $('.bundle-preview_cart-items').find(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"]`).attr('data-qty',currentqty);
    $('.bundle-preview_cart-items').find(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"] [name="bundle_quantity"]`).val(currentqty);
    // if($('.bundle-preview_cart-items').find(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"]`).length > 0){
      
    // }else{
      // var featuredimage = $(this).closest('.product-card-wrapper').attr('data-featuredimage');
      // var itemtitle = $(this).closest('.product-card-wrapper').attr('data-product-name');
      // var itembox = `<div class="bundle-preview_cart-item-wrapper" 
      // data-qty="${currentqty}"
      // data-vid="${$(this).closest('.product-card-wrapper').attr('data-variant-id')}" 
      // data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"
      // data-price="${$(this).closest('.product-card-wrapper').attr('data-product-price')}"
      // >
      // <img src="${featuredimage}" loading="lazy" width="70" height="70" alt="">
      // <h4 class="itemtitle">${itemtitle}</h4>
      // <div class="bndl-preview-qtybox">
      //   <div class="quantity">
      //     <button class="quantity__button minus" type="button">
      //       <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
      //         <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
      //         </path>
      //       </svg>
      //     </button>
      //     <input class="quantity__input" type="number" name="bundle_quantity" value="1" readonly>
      //     <button class="quantity__button plus" type="button">
      //       <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
      //         <path fill-rule="evenodd"o clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
      //       </svg>
      //     </button>
      //   </div>
      // </div>
      // <div class="hidden bundle-preview_car-item-remove text--xsmall">x</div>
      // </div>`; 
      // $('.bundle-preview_cart-items').append(itembox);  
    // }
    
  });

  $('body').on('click', '.bundle-products-mainwrapper .product-card-wrapper .quantity__button[name="minus"]', function(e){
    addedcnt = addedcnt - 1;
    // bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-compare_price'));
    bundle_total_price = bundle_total_price - parseInt($(this).closest('.card__content').find('.bundle-product-item__cta').attr('data-price'));
    activecheck(addedcnt,bundle_compare_price,bundle_total_price); 
    var currentqty = parseInt($(this).closest('.quantity').find('[name="quantity"]').val());
    qtyatc(currentqty, this);
    console.log(currentqty + 1)
    if(currentqty == 0){
      $(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"]`).remove();
      // $('.bundle-preview_cart-items').find(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"]`).attr('data-qty',currentqty);
      // $('.bundle-preview_cart-items').find(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"] [name="bundle_quantity"]`).val(currentqty);
    }else{
      $('.bundle-preview_cart-items').find(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"]`).attr('data-qty',currentqty);
      $('.bundle-preview_cart-items').find(`.bundle-preview_cart-item-wrapper[data-pid="${$(this).closest('.product-card-wrapper').attr('data-product-id')}"] [name="bundle_quantity"]`).val(currentqty);  
    }
    
    
    // $(`.bundle-preview_cart-item[data-qty="${currentqty + 1}"][data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');    
    
  });

  $('body').on('click','.bundle-preview_cart-item-wrapper .quantity__button', function(){
    var thiscard = $(this).closest('.bundle-products-mainwrapper').find(`.product-card-wrapper[data-product-id="${$(this).closest('.bundle-preview_cart-item-wrapper').attr('data-pid')}"]`);
    var qtyinput = $(this).closest('.quantity').find('[name="bundle_quantity"]');
    if($(this).hasClass('plus')){
      addedcnt += 1;
      var newqty = parseInt(qtyinput.val()) + 1;
      qtyinput.val(newqty);
      bundle_total_price += parseInt(thiscard.find('.bundle-product-item__cta').attr('data-price'));
    }else{
      addedcnt = addedcnt - 1;
      var newqty = parseInt(qtyinput.val()) - 1;
      qtyinput.val(newqty);
      bundle_total_price = bundle_total_price - parseInt(thiscard.find('.bundle-product-item__cta').attr('data-price'));
    }
    
    
    var currentqty = newqty;
    qtyatc(currentqty, thiscard.find('.bundle-product-item__cta'));
    
    activecheck(addedcnt,bundle_compare_price,bundle_total_price);     
    if(currentqty == 0){
      $(this).closest('.bundle-preview_cart-item-wrapper').remove();
    }else{
      $(this).closest('.bundle-preview_cart-item-wrapper').attr('data-qty',currentqty);
      $(this).closest(`.quantity`).find(`[name="bundle_quantity"]`).val(currentqty);
    }
    thiscard.find('[name="quantity"]').val(currentqty);  
  });
  
  // $('body').on('click','.bundle-preview_car-item-remove', function(){
  //   addedcnt = addedcnt - 1;
  //   bundle_total_price = bundle_total_price - parseInt($(this).closest('.bundle-products-mainwrapper').find(`.product-card-wrapper[data-product-id="${$(this).closest('.bundle-preview_cart-item-wrapper').attr('data-pid')}"]`).find('.bundle-product-item__cta').attr('data-price'));
  //   // bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price'));
  //   activecheck(addedcnt,bundle_compare_price,bundle_total_price); 
  //   var currentqty = $(this).closest('.bundle-products-mainwrapper').find(`.product-card-wrapper[data-product-id="${$(this).closest('.bundle-preview_cart-item-wrapper').attr('data-pid')}"]`).find('[name="quantity"]').val();
  //   var tochangeqty = parseInt(currentqty) - 1;
  //   $(this).closest('.bundle-products-mainwrapper').find(`.product-card-wrapper[data-product-id="${$(this).closest('.bundle-preview_cart-item-wrapper').attr('data-pid')}"]`).find('[name="quantity"]').val(tochangeqty);
  //   if(tochangeqty == 0){
  //     $(this).closest('.bundle-products-mainwrapper').find(`.product-card-wrapper[data-product-id="${$(this).closest('.bundle-preview_cart-item-wrapper').attr('data-pid')}"]`).find('.quantity').addClass('hidden');
  //     $(this).closest('.bundle-products-mainwrapper').find(`.product-card-wrapper[data-product-id="${$(this).closest('.bundle-preview_cart-item-wrapper').attr('data-pid')}"]`).find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').html(`Added`).show();
  //   }
  //   $(this).closest('.bundle-preview_cart-item-wrapper').remove();
  // });

  $('body').on('click','.bundle-add_to_cart_button.readytoadd ', function(){
    var items = [];
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item-wrapper').each(function(i,v){
      var val = $(this).attr('data-vid');
      var qty = $(this).find('[name="bundle_quantity"]').val();
      var p_title = $(this).attr('product-title');
       items.push({
        quantity: qty,
        id: val,
        properties: {
          '_product_title': p_title,
        }
      });   
    });    
    
    var data = {items};

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    if (window.cart) {
      data.sections = window.cart.getSectionsToRender().map((section) => section.id);
      data.sections_url = window.location.pathname;
      window.cart.setActiveElement(document.activeElement);
    }
    
    config.body = JSON.stringify(data);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {            
        if (!window.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: data.items[0].id,
          cartData: response,
        });  
        
        window.cart.renderContents(response);
      })
      .catch((error) => {
        console.error("Add to Cart Error:", error);
      })
      .finally(() => {
        if (window.cart && window.cart.classList.contains('is-empty')) {
          window.cart.classList.remove('is-empty');
        }
      });    
    
  });

  $('body').on('click','.bundle-product-list .review_drawer_button', function(){
    $('.bundle-preview_cart').addClass('active');
    $('.bundle-product-list .bundle_overlay').addClass('active');
  });
  
  $('body').on('click','.bundle-product-list .close_model,.bundle-product-list .bundle_overlay', function(){
    $('.bundle-preview_cart').removeClass('active');
    $('.bundle-product-list .bundle_overlay').removeClass('active');
  });
  
});
